import React, { memo } from "react";

import Icon from "app/components/Icon/Icon";
import { ReactComponent } from "./svgs/positive_test_flows.svg";

export const PositiveTestFlowsIcons = memo(() => {
  return <Icon component={ReactComponent} />;
});
